module.exports = __webpack_public_path__ + "static/fonts/open-sans-v15-cyrillic-regular.ca41c45.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/open-sans-v15-cyrillic-regular.woff2
// module id = 59
// module chunks = 0